"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Chars;
(function (Chars) {
    Chars["Alpha"] = "alpha";
    Chars["AlphaLower"] = "alphaLower";
    Chars["Numeric"] = "numeric";
    Chars["Special"] = "special";
    Chars["AlphaNumeric"] = "alphaNumeric";
    Chars["AlphaNumericLower"] = "alphaNumericLower";
    Chars["Full"] = "full";
})(Chars = exports.Chars || (exports.Chars = {}));
var Pattern;
(function (Pattern) {
    Pattern["ALPHA"] = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    Pattern["ALPHA_LOWER"] = "abcdefghijklmnopqrstuvwxyz";
    Pattern["NUMERIC"] = "0123456789";
    Pattern["SPECIAL"] = "!@#$%^&*()-_=+[{]}<>";
})(Pattern = exports.Pattern || (exports.Pattern = {}));
